<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-tabs :active-key="String(query.csc)" @change="changeServiceType">
        <a-tab-pane key="1" tab="国内现货客服" />
        <a-tab-pane key="2" tab="定制专属客服" />
      </a-tabs>
      <a-alert class="actions" type="info" show-icon :message="query.csc === 1 ? '现货客服按 DK 分类分管商品，下级分类继承上级客服。' : '专属客服按客户提供定制服务，支持将选中客户迁移给其他专属客服。'" />
      <a-form layout="inline" class="bar">
        <a-form-item label="关键词"><a-input v-model="query.keyword" allow-clear placeholder="账号/名称/手机号/邮箱/客服码" /></a-form-item>
        <a-form-item label="状态">
          <a-select v-model="query.status" allow-clear style="width:100px"><a-select-option :value="1">启用</a-select-option><a-select-option :value="0">停用</a-select-option></a-select>
        </a-form-item>
        <a-form-item><a-button type="primary" @click="search">查询</a-button><a-button class="ml" @click="reset">重置</a-button></a-form-item>
      </a-form>
      <div class="actions"><a-button v-hasPermi="['dkmall:customer-service-agent:add']" type="primary" icon="plus" @click="openAdd">新增客服</a-button></div>
      <a-table
        row-key="id"
        :loading="loading"
        :data-source="rows"
        :columns="displayColumns"
        :scroll="{x:2440}"
        :pagination="pagination"
        bordered
        @change="pageChange">
        <template slot="agent" slot-scope="t,r">
          <a-avatar :src="r.avatar" icon="user" /><span class="agent-name">{{ r.nickname || r.real_name || '-' }}</span>
          <div class="muted">账号：{{ r.account || '-' }}</div>
        </template>
        <template slot="type" slot-scope="t,r"><a-tag :color="Number(r.csc)===1?'blue':'purple'">{{ Number(r.csc)===1?'国内现货客服':'定制专属客服' }}</a-tag></template>
        <template slot="contact" slot-scope="t,r"><div>{{ r.mobile || '-' }}</div><div class="muted">{{ r.email || '-' }}</div></template>
        <template slot="status" slot-scope="t,r"><a-badge :status="Number(r.status)===1?'success':'default'" :text="Number(r.status)===1?'启用':'停用'" /></template>
        <template slot="regions" slot-scope="t,r"><div><a-tag :color="Number(r.service_domestic_enabled)===1?'green':''">国内版：{{ Number(r.service_domestic_enabled)===1?'开启':'关闭' }}</a-tag></div><div v-if="Number(r.csc)!==1"><a-tag :color="Number(r.service_international_enabled)===1?'green':''">国际版：{{ Number(r.service_international_enabled)===1?'开启':'关闭' }}</a-tag></div></template>
        <template slot="sales" slot-scope="t,r"><div>人民币 ¥{{ money(r.sales_cny) }}</div><div>美元 ${{ money(r.sales_usd) }}</div></template>
        <template slot="time" slot-scope="t,r">{{ formatTime(r.update_time || r.create_time) }}</template>
        <template slot="products" slot-scope="t,r"><a @click="openProducts(r)">查看分管商品</a></template>
        <template slot="clients" slot-scope="t,r"><a @click="openClients(r)">{{ r.client_count || 0 }} 人</a></template>
        <template slot="op" slot-scope="t,r"><a @click="openClients(r)">客户列表</a><a-divider type="vertical"/><a @click="openOrders(r)">历史订单</a><a-divider type="vertical"/><a @click="openPerformance(r,'summary')">详情 / 统计</a><a-divider type="vertical"/><a @click="openPerformance(r,'ratings')">客户评价</a><a-divider type="vertical"/><a @click="openPerformance(r,'complaints')">投诉管理</a><a-divider type="vertical"/><a v-hasPermi="['dkmall:customer-service-agent:edit']" @click="openEdit(r)">编辑</a><template v-if="Number(r.csc)===2"><a-divider type="vertical"/><a v-hasPermi="['dkmall:customer-service-agent:edit']" @click="openMigrate(r)">迁移客户</a></template><a-divider type="vertical"/><a-popconfirm title="确定删除该客服？有关联客户时将禁止删除。" @confirm="remove(r)"><a v-hasPermi="['dkmall:customer-service-agent:delete']" class="danger">删除</a></a-popconfirm></template>
      </a-table>

      <a-modal
        :title="form.id?'编辑客服':'新增客服'"
        :visible="visible"
        :confirm-loading="saving"
        width="720px"
        @ok="save"
        @cancel="visible=false">
        <a-form-model ref="agentForm" :model="form" :rules="rules" :label-col="{span:6}" :wrapper-col="{span:16}">
          <a-row :gutter="16">
            <a-col :span="12"><a-form-model-item label="登录账号" prop="account"><a-input v-model="form.account" maxlength="80" /></a-form-model-item></a-col>
            <a-col :span="12"><a-form-model-item :label="form.id?'重置密码':'登录密码'" :prop="form.id?'':'password'"><a-input-password v-model="form.password" :placeholder="form.id?'不修改请留空':'请输入登录密码'" /></a-form-model-item></a-col>
            <a-col :span="12"><a-form-model-item label="客服名称" prop="nickname"><a-input v-model="form.nickname" maxlength="80" /></a-form-model-item></a-col>
            <a-col :span="12"><a-form-model-item label="真实姓名"><a-input v-model="form.realName" maxlength="80" /></a-form-model-item></a-col>
            <a-col :span="12"><a-form-model-item label="客服类型" prop="csc"><a-select v-model="form.csc"><a-select-option :value="1">国内现货客服</a-select-option><a-select-option :value="2">定制专属客服</a-select-option></a-select></a-form-model-item></a-col>
            <a-col :span="12"><a-form-model-item v-if="Number(form.csc)!==1" label="客服码" prop="customerServiceCode"><a-input v-model="form.customerServiceCode" maxlength="80" /></a-form-model-item></a-col>
            <a-col :span="12"><a-form-model-item label="手机号"><a-input v-model="form.mobile" maxlength="30" /></a-form-model-item></a-col>
            <a-col :span="12"><a-form-model-item label="邮箱"><a-input v-model="form.email" maxlength="120" /></a-form-model-item></a-col>
            <a-col :span="12"><a-form-model-item label="国家区号"><a-input v-model="form.areaCode" maxlength="10" /></a-form-model-item></a-col>
            <a-col :span="12"><a-form-model-item v-if="Number(form.csc)!==1" label="职务"><a-input v-model="form.position" maxlength="100" /></a-form-model-item></a-col>
            <a-col :span="24"><a-form-model-item label="头像" :label-col="{span:3}" :wrapper-col="{span:20}"><file-upload :value="form.avatar || ''" type="image" accept="image/*" :count="1" @change="value=>form.avatar=typeof value==='string'?value:((value&&(value.path||value.url))||'')"/><div class="muted">建议上传正方形图片，单张不超过 2MB</div></a-form-model-item></a-col>
            <a-col v-if="Number(form.csc)===1" :span="24"><div class="muted" style="margin:0 24px 16px">现货客服仅服务国内版，不提供国际版开关，保存时会自动关闭国际版。</div></a-col>
            <a-col v-if="Number(form.csc)!==1" :span="12"><a-form-model-item label="国内版"><a-switch :checked="form.serviceDomesticEnabled===1" @change="v=>form.serviceDomesticEnabled=v?1:0" /></a-form-model-item></a-col>
            <a-col v-if="Number(form.csc)!==1" :span="12"><a-form-model-item label="国际版"><a-switch :checked="form.serviceInternationalEnabled===1" @change="v=>form.serviceInternationalEnabled=v?1:0" /></a-form-model-item></a-col>
            <a-col v-if="Number(form.csc)===2" :span="24"><div class="muted" style="margin:0 24px 16px">无客服码注册时，按版本从开启的专属客服中随机分配；填写客服码不受版本开关限制。两个都关闭时不参与自动分配。</div></a-col>
            <a-col :span="12"><a-form-model-item label="状态"><a-radio-group v-model="form.status"><a-radio :value="1">启用</a-radio><a-radio :value="0">停用</a-radio></a-radio-group></a-form-model-item></a-col>
            <a-col :span="12"><a-form-model-item label="排序"><a-input-number v-model="form.sort" :min="0" :max="9999" style="width:100%" /></a-form-model-item></a-col>
          </a-row>
        </a-form-model>
      </a-modal>

      <a-drawer :title="`服务客户 · ${clientAgent ? (clientAgent.real_name || clientAgent.nickname) : ''}`" :visible="clientVisible" width="calc(100vw - 48px)" @close="clientVisible=false">
        <div class="actions"><a-input-search v-model="clientKeyword" allow-clear placeholder="搜索客户 ID / 昵称 / 姓名 / 手机 / 邮箱 / 企业" style="width:420px" /></div>
        <a-table
          row-key="id"
          size="small"
          :loading="clientLoading"
          :data-source="filteredClientRows"
          :columns="clientColumns"
          :pagination="{ pageSize: 20, showTotal: t => `共 ${t} 人` }"
          :scroll="{ x: 2050, y: 'calc(100vh - 230px)' }"
          bordered>
          <template slot="customer" slot-scope="t,r"><dk-member-identity :record="r" /></template>
          <template slot="clientContact" slot-scope="t,r"><div>{{r.area_code || ''}} {{r.mobile || '-'}}</div><div class="muted">{{r.email || '-'}}</div></template>
          <template slot="clientCert" slot-scope="t,r"><a-tag>{{r.cert_status_text || '未认证'}}</a-tag><div class="muted">默认企业：{{r.default_enterprise_name || '-'}}</div><div class="muted">认证姓名：{{r.cert_real_name || '-'}}</div><div class="muted">认证手机：{{r.cert_phone_text || '-'}}</div><div class="muted">认证邮箱：{{r.cert_email_text || '-'}}</div></template>
          <template slot="assignedService" slot-scope="t,r"><a-avatar :src="r.service_avatar" icon="user" :size="28" /> {{ r.service_real_name || r.service_nickname || '-' }}<div class="muted">客服码：{{ r.service_code || '-' }}</div><div class="muted">{{ r.service_mobile || '-' }} / {{ r.service_email || '-' }}</div></template>
          <template slot="clientUpdated" slot-scope="t,r">{{ formatTime(r.update_time) }}</template>
          <template slot="clientCreated" slot-scope="t,r">{{ formatTime(r.create_time) }}</template>
          <template slot="clientStatus" slot-scope="t,r">{{Number(r.status)===1?'正常':'停用'}}</template>
        </a-table>
      </a-drawer>
      <a-modal title="更换客户专属客服" :visible="clientChangeVisible" :confirm-loading="saving" @ok="saveClientChange" @cancel="!saving && (clientChangeVisible=false)">
        <p>客户：{{ clientChangeRow ? (clientChangeRow.real_name || clientChangeRow.nickname || clientChangeRow.id) : '' }}</p>
        <a-select
          v-model="clientChangeToId"
          :loading="clientChangeLoading"
          :disabled="clientChangeLoading || saving"
          style="width:100%"
          show-search
          option-filter-prop="children"
          placeholder="选择其他专属客服">
          <a-select-option v-for="agent in clientChangeAgents" :key="agent.id" :value="agent.id">{{ agent.real_name || agent.nickname }} / {{ agent.mobile || '-' }} / ID {{ agent.id }}</a-select-option>
        </a-select>
      </a-modal>
      <a-modal
        title="迁移客户到其他业务员"
        :visible="migrateVisible"
        :confirm-loading="saving"
        width="1280px"
        ok-text="迁移选中客户"
        :ok-button-props="{ props: { disabled: migrateLoading || !selectedClientIds.length } }"
        @ok="saveMigrate"
        @cancel="closeMigrate">
        <p>「{{ migrateFrom ? (migrateFrom.real_name || migrateFrom.nickname) : '' }}」名下客户：共 {{ migrateRows.length }} 人，已选 {{ selectedClientIds.length }} 人。</p>
        <div class="actions">
          <a-button :disabled="migrateLoading || saving" @click="selectAllClients">全选全部客户</a-button>
          <a-button class="ml" :disabled="saving" @click="selectedClientIds=[]">取消选择</a-button>
        </div>
        <a-table
          row-key="id"
          size="small"
          :loading="migrateLoading"
          class="migrate-clients-table"
          :data-source="migrateRows"
          :columns="migrateColumns"
          :row-selection="{ columnWidth: 60, selectedRowKeys: selectedClientIds, onChange: selectClients, getCheckboxProps: () => ({ props: { disabled: saving } }) }"
          :pagination="{ pageSize: 20, showTotal: t => `共 ${t} 人` }"
          :scroll="{ x: 1690, y: 360 }"
          bordered>
          <template slot="customer" slot-scope="t,r"><dk-member-identity :record="r" /></template>
          <template slot="clientContact" slot-scope="t,r"><div>{{r.area_code || ''}} {{r.mobile || '-'}}</div><div class="muted">{{r.email || '-'}}</div></template>
          <template slot="clientCert" slot-scope="t,r"><a-tag>{{r.cert_status_text || '未认证'}}</a-tag><div class="muted">默认企业：{{r.default_enterprise_name || '-'}}</div><div class="muted">认证姓名：{{r.cert_real_name || '-'}}</div><div class="muted">认证手机：{{r.cert_phone_text || '-'}}</div><div class="muted">认证邮箱：{{r.cert_email_text || '-'}}</div></template>
          <template slot="assignedService" slot-scope="t,r"><a-avatar :src="r.service_avatar" icon="user" :size="28"/> {{r.service_real_name || r.service_nickname || '-'}}<div class="muted">{{r.service_mobile || '-'}} · {{r.service_code || '-'}}</div></template>
        </a-table>
        <a-form-item label="迁移到其他业务员" style="margin-top:16px">
          <a-select
            v-model="migrateToId"
            :disabled="migrateLoading || saving"
            style="width:100%"
            show-search
            option-filter-prop="children"
            placeholder="选择目标业务员（姓名 / 手机 / ID）">
            <a-select-option v-for="item in migrateAgents" :key="item.id" :value="item.id">
              {{ item.real_name || item.nickname }} / {{ item.mobile || '-' }} / ID {{ item.id }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-modal>
      <a-drawer :title="`分管商品 · ${productAgent ? (productAgent.real_name || productAgent.nickname) : ''}`" :visible="productVisible" width="1000" @close="productVisible=false">
        <a-alert type="info" show-icon message="分管关系在商品管理 → DK分类的一级分类中配置客服；下方展示分管一级分类及其下属分类的主商品。" />
        <h4 style="margin-top:16px">分管一级分类</h4>
        <a-tag v-for="category in productCategories" :key="category.aid">{{ category.name }} {{ category.name_en || '' }}</a-tag>
        <a-empty v-if="!productLoading && !productCategories.length" description="尚未配置分管分类" />
        <h4 style="margin-top:16px">分管主商品（{{ productTotal }}）</h4>
        <a-table
          row-key="aid"
          :loading="productLoading"
          :data-source="productRows"
          :columns="productColumns"
          :pagination="{ current: productPage, pageSize: 20, total: productTotal }"
          bordered
          @change="productPageChange">
          <template slot="image" slot-scope="t,r"><a-avatar shape="square" :size="56" :src="r.thumb" icon="picture" /></template>
          <template slot="productName" slot-scope="t,r"><div>{{ r.name || '-' }}</div><div class="muted">{{ r.name_en || '-' }}</div></template>
          <template slot="sale" slot-scope="t,r"><a-tag :color="Number(r.is_sale)===1?'green':''">{{ Number(r.is_sale)===1?'上架':'下架' }}</a-tag></template>
        </a-table>
      </a-drawer>
      <performance-drawer :agent="performanceAgent" :visible="performanceVisible" :initial-tab="performanceTab" @close="performanceVisible=false" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listServiceAgents, getServiceAgent, addServiceAgent, updateServiceAgent, deleteServiceAgent, listAgentClients, listAgentProducts, migrateAgentClients } from '@/api/dkmall/customer-service'

import PerformanceDrawer from './PerformanceDrawer.vue'
import DkMemberIdentity from '@/components/DkMemberIdentity'

const emptyForm = () => ({ account: '', password: '', nickname: '', realName: '', avatar: '', mobile: '', email: '', areaCode: '86', customerServiceCode: '', csc: 1, position: '', serviceDomesticEnabled: 1, serviceInternationalEnabled: 1, status: 1, sort: 100 })
export default {
  name: 'DkMallServiceAgents',
  components: { PerformanceDrawer, DkMemberIdentity },
  data () {
    return {
      loading: false,
      performanceAgent: null,
      performanceVisible: false,
      performanceTab: 'summary',
      feedbackRoute: this.$route.path,
      saving: false,
      visible: false,
      rows: [],
      total: 0,
      query: { pageNum: 1, pageSize: 20, csc: 1 },
      form: emptyForm(),
      rules: { account: [{ required: true, message: '请输入登录账号' }], password: [{ required: true, message: '请输入登录密码' }], nickname: [{ required: true, message: '请输入客服名称' }], csc: [{ required: true, message: '请选择客服类型' }], customerServiceCode: [{ required: true, message: '请输入客服码' }] },
      columns: [
        { title: '客服信息', scopedSlots: { customRender: 'agent' }, width: 270 },
        { title: '真实姓名', dataIndex: 'real_name', width: 140 },
        { title: '客服码', dataIndex: 'customer_service_code', width: 120 },
        { title: '版本开关', scopedSlots: { customRender: 'regions' }, width: 150 },
        { title: '销售订单', dataIndex: 'sales_order_count', width: 100 },
        { title: '销售金额（人民币/美元）', scopedSlots: { customRender: 'sales' }, width: 200 },
        { title: '客服类型', scopedSlots: { customRender: 'type' }, width: 130 },
        { title: '联系方式', scopedSlots: { customRender: 'contact' }, width: 180 },
        { title: '服务客户', scopedSlots: { customRender: 'clients' }, width: 100 },
        { title: '职务', dataIndex: 'position' }, { title: '状态', scopedSlots: { customRender: 'status' }, width: 90 },
        { title: '更新时间', scopedSlots: { customRender: 'time' }, width: 170 }, { title: '操作', scopedSlots: { customRender: 'op' }, width: 360, fixed: 'right' }
      ],
      productVisible: false,
      productAgent: null,
      productRows: [],
      productCategories: [],
      productLoading: false,
      productPage: 1,
      productTotal: 0,
      productColumns: [
        { title: '主图', scopedSlots: { customRender: 'image' }, width: 80 },
        { title: '子商品货号', dataIndex: 'child_sns', width: 260, customRender: value => value || '--' },
        { title: '商品名称（中/英）', scopedSlots: { customRender: 'productName' } },
        { title: '分类', dataIndex: 'category_name', width: 160 },
        { title: '状态', scopedSlots: { customRender: 'sale' }, width: 80 }
      ],
      clientVisible: false,
      clientAgent: null,
      clientRows: [],
      clientLoading: false,
      clientKeyword: '',
      clientRequest: 0,
      clientChangeVisible: false,
      clientChangeRow: null,
      clientChangeFromId: null,
      clientChangeToId: undefined,
      clientChangeAgents: [],
      clientChangeLoading: false,
      clientColumns: [
        { title: '用户(头像/昵称/ID)', scopedSlots: { customRender: 'customer' }, width: 230 },
        { title: '注册手机/邮箱', scopedSlots: { customRender: 'clientContact' }, width: 180 },
        { title: '企业认证', scopedSlots: { customRender: 'clientCert' }, width: 280 },
        { title: '默认收货地址', dataIndex: 'default_address', width: 220 },
        { title: '国家', dataIndex: 'country', width: 80 },
        { title: '当前客服', scopedSlots: { customRender: 'assignedService' }, width: 260 },
        { title: '画册权益', dataIndex: 'brochure_status_text', width: 200 },
        { title: '最后登录', dataIndex: 'last_login_time_text', width: 160 },
        { title: '注册时间', scopedSlots: { customRender: 'clientCreated' }, width: 160 },
        { title: '状态', scopedSlots: { customRender: 'clientStatus' }, width: 90 },
        { title: '更新时间', scopedSlots: { customRender: 'clientUpdated' }, width: 170 }
      ],
migrateVisible: false,
      migrateFrom: null,
      migrateToId: undefined,
      migrateRows: [],
      migrateAgents: [],
      selectedClientIds: [],
      migrateLoading: false,
      migrateRequest: 0,
      migrateColumns: [
        { title: '用户(头像/昵称/ID)', scopedSlots: { customRender: 'customer' }, width: 230 },
        { title: '注册手机/邮箱', scopedSlots: { customRender: 'clientContact' }, width: 180 },
        { title: '所属国家', dataIndex: 'country', width: 90 },
        { title: '企业认证(状态/企业/姓名/联系方式)', scopedSlots: { customRender: 'clientCert' }, width: 280 },
        { title: '默认收货地址', dataIndex: 'default_address', width: 240 },
        { title: '专属客服', scopedSlots: { customRender: 'assignedService' }, width: 230 },
        { title: '画册权益', dataIndex: 'brochure_status_text', width: 220 },
        { title: '最后登录', dataIndex: 'last_login_time_text', width: 160 }
      ]
    }
  },
  computed: {
    filteredClientRows () {
      const keyword = this.clientKeyword.trim().toLowerCase()
      return keyword ? this.clientRows.filter(row => ['id', 'account', 'nickname', 'real_name', 'mobile', 'email', 'enterprise_name'].some(key => String(row[key] || '').toLowerCase().includes(keyword))) : this.clientRows
    },
    displayColumns () {
      return this.columns.filter(column => this.query.csc !== 1 || !['position','customer_service_code'].includes(column.dataIndex)).map(column => column.scopedSlots && column.scopedSlots.customRender === 'clients' && this.query.csc === 1
        ? { title: '分管商品', scopedSlots: { customRender: 'products' }, width: 140 } : column)
    },
    pagination () { return { current: this.query.pageNum, pageSize: this.query.pageSize, total: this.total, showTotal: t => `共 ${t} 条`, showSizeChanger: true } } },
  created () { this.load();this.openDashboardFeedback() },
  watch: { '$route.query' () { this.openDashboardFeedback() } },
  methods: {
    money (value) { return Number(value || 0).toFixed(2) },
    openOrders (agent) { this.$router.push({path:'/dkmall/dkmall-order/order-list',query:{serviceId:String(agent.id),serviceName:agent.real_name || agent.nickname || String(agent.id)}}) },
    openPerformance (agent,tab) { this.performanceVisible=false;this.performanceAgent=agent;this.performanceTab=tab;this.$nextTick(()=>{this.performanceVisible=true}) },
    openDashboardFeedback () {
      if(this.$route.path!==this.feedbackRoute)return
      const query=this.$route.query || {};const id=Number(query.agentId)
      if(!Number.isSafeInteger(id)||id<=0||!['ratings','complaints'].includes(query.feedbackTab))return
      return getServiceAgent(id).then(response=>{if(this.$route.path!==this.feedbackRoute||Number(this.$route.query.agentId)!==id||this.$route.query.feedbackTab!==query.feedbackTab)return;this.openPerformance(response.data,query.feedbackTab)})
    },
    load () { this.loading = true; listServiceAgents(this.query).then(res => { this.rows = (res.data && res.data.rows) || []; this.total = Number((res.data && res.data.total) || 0) }).finally(() => { this.loading = false }) },
    changeServiceType (key) { this.query = { pageNum: 1, pageSize: 20, csc: Number(key) }; this.load() },
    openProducts (row) { this.productAgent = row; this.productRows = []; this.productCategories = []; this.productTotal = 0; this.productPage = 1; this.productVisible = true; return this.loadProducts() },
    async loadProducts () {
      const id = this.productAgent.id
      const page = this.productPage
      this.productLoading = true
      try {
        const res = await listAgentProducts(id, { pageNum: page, pageSize: 20 })
        if (this.productAgent.id !== id || this.productPage !== page) return
        const data = res.data || {}
        this.productRows = data.rows || []
        this.productCategories = data.categories || []
        this.productTotal = Number(data.total || 0)
      } finally { if (this.productAgent.id === id && this.productPage === page) this.productLoading = false }
    },
    productPageChange (pagination) { this.productPage = pagination.current; this.loadProducts() },
    search () { this.query.pageNum = 1; this.load() },
    reset () { this.query = { pageNum: 1, pageSize: 20, csc: this.query.csc }; this.load() },
    pageChange (p) { this.query.pageNum = p.current; this.query.pageSize = p.pageSize; this.load() },
    openAdd () { this.form = { ...emptyForm(), csc: this.query.csc }; this.visible = true; this.$nextTick(() => this.$refs.agentForm && this.$refs.agentForm.clearValidate()) },
    openEdit (row) { getServiceAgent(row.id).then(res => { const d = res.data || {}; this.form = { ...emptyForm(), ...d, csc: Number(d.csc || 1), status: Number(d.status == null ? 1 : d.status), realName: d.real_name || '', areaCode: d.area_code || '86', serviceDomesticEnabled: d.service_domestic_enabled == null ? 1 : Number(d.service_domestic_enabled), serviceInternationalEnabled: d.service_international_enabled == null ? 1 : Number(d.service_international_enabled), customerServiceCode: d.customer_service_code || '', password: '' }; this.visible = true }) },
    save () { this.$refs.agentForm.validate(valid => { if (!valid) return; this.saving = true; const request = this.form.id ? updateServiceAgent(this.form.id, this.form) : addServiceAgent(this.form); request.then(() => { this.$message.success(this.form.id ? '修改成功' : '新增成功'); this.visible = false; this.load() }).finally(() => { this.saving = false }) }) },
    remove (row) { deleteServiceAgent(row.id).then(() => { this.$message.success('删除成功'); this.load() }) },
    async openClients (row) {
      const request = ++this.clientRequest
      this.clientAgent = row
      this.clientKeyword = ''
      this.clientRows = []
      this.clientVisible = true
      this.clientLoading = true
      try {
        const rows = await this.allPages(params => listAgentClients(row.id, params))
        if (request === this.clientRequest) this.clientRows = rows
      } finally { if (request === this.clientRequest) this.clientLoading = false }
    },
    async openClientChange (row) {
      if (!this.clientAgent || Number(this.clientAgent.csc) !== 2) return
      this.clientChangeRow = row
      this.clientChangeFromId = this.clientAgent.id
      this.clientChangeToId = undefined
      this.clientChangeAgents = []
      this.clientChangeVisible = true
      this.clientChangeLoading = true
      try {
        const agents = await this.allPages(params => listServiceAgents({ ...params, status: 1, csc: 2 }))
        this.clientChangeAgents = agents.filter(agent => String(agent.id) !== String(this.clientChangeFromId))
      } finally { this.clientChangeLoading = false }
    },
    async saveClientChange () {
      if (this.saving || this.clientChangeLoading) return
      if (!this.clientChangeToId) return this.$message.warning('请选择其他专属客服')
      this.saving = true
      try {
        await migrateAgentClients({ fromId: this.clientChangeFromId, toId: this.clientChangeToId, userIds: [this.clientChangeRow.id] })
        this.$message.success('更换客服成功')
        this.clientChangeVisible = false
        await this.openClients(this.clientAgent)
        this.load()
      } finally { this.saving = false }
    },
async allPages (request) {
      const rows = []
      for (let pageNum = 1; ; pageNum++) {
        const res = await request({ pageNum, pageSize: 100 })
        const data = res.data || {}
        const batch = data.rows || []
        rows.push(...batch)
        if (rows.length >= Number(data.total || 0) || !batch.length) return rows
      }
    },
    async openMigrate (row) {
      if (Number(row.csc) !== 2) return this.$message.warning('现货客服按商品分类分管，不支持迁移客户')
      const requestId = ++this.migrateRequest
      this.migrateFrom = row
      this.migrateToId = undefined
      this.migrateRows = []
      this.migrateAgents = []
      this.selectedClientIds = []
      this.migrateVisible = true
      this.migrateLoading = true
      try {
        const [clients, agents] = await Promise.all([
          this.allPages(params => listAgentClients(row.id, params)),
          this.allPages(params => listServiceAgents({ ...params, status: 1, csc: 2 }))
        ])
        if (requestId !== this.migrateRequest) return
        this.migrateRows = clients
        this.migrateAgents = agents.filter(item => String(item.id) !== String(row.id))
      } catch (error) {
        if (requestId === this.migrateRequest) this.$message.error('客户或业务员列表加载失败，请重新打开迁移窗口')
      } finally {
        if (requestId === this.migrateRequest) this.migrateLoading = false
      }
    },
    closeMigrate () { if (this.saving) return; this.migrateRequest++; this.migrateVisible = false },
    selectClients (ids) { this.selectedClientIds = ids },
    selectAllClients () { this.selectedClientIds = this.migrateRows.map(row => row.id) },
    async saveMigrate () {
      if (this.migrateLoading || this.saving) return
      if (!this.selectedClientIds.length) return this.$message.warning('请先勾选需要迁移的客户')
      if (!this.migrateToId) return this.$message.warning('请选择目标业务员')
      this.saving = true
      try {
        const res = await migrateAgentClients({ fromId: this.migrateFrom.id, toId: this.migrateToId, userIds: [...this.selectedClientIds] })
        this.$message.success(`已迁移 ${res.data || 0} 名客户`)
        this.migrateVisible = false
        this.load()
      } finally {
        this.saving = false
      }
    },
    formatTime (v) { if (!v) return '-'; const n = Number(v); return new Date(n < 1000000000000 ? n * 1000 : n).toLocaleString() }
  }
}
</script>

<style scoped>
.bar{margin-bottom:16px}.actions{margin-bottom:16px}.ml{margin-left:8px}.agent-name{margin-left:10px}.muted{color:#888;font-size:12px;margin-top:4px}.danger{color:#f5222d}
/* Keep identity and selection in the same rows as the multiline customer details.
   Ant Design Vue 1's cloned fixed-column table measures different row heights in this modal. */
.migrate-clients-table /deep/ .ant-table-thead > tr > th:nth-child(-n+2),
.migrate-clients-table /deep/ .ant-table-tbody > tr > td:nth-child(-n+2) {
  position: sticky;
  left: 0;
  z-index: 2;
  background: #fff;
}
.migrate-clients-table /deep/ .ant-table-thead > tr > th:nth-child(2),
.migrate-clients-table /deep/ .ant-table-tbody > tr > td:nth-child(2) { left: 60px; }
.migrate-clients-table /deep/ .ant-table-thead > tr > th:nth-child(-n+2) { background: #fafafa !important; z-index: 3; }
.migrate-clients-table /deep/ .ant-table-tbody > tr:hover > td,
.migrate-clients-table /deep/ .ant-table-tbody > tr.ant-table-row-selected > td { background: #f5f5f5; }
.migrate-clients-table /deep/ .ant-table-body { overscroll-behavior: contain; }
</style>
